import React, { useState, useEffect } from 'react';
import { Button, Modal, Input } from 'reactstrap';
import './Modal.css';
import { doLogin, cleanLoginError ,cleanRecoveryEmail} from '../../store/actions/actions';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import { useHistory } from 'react-router';
import { useTranslation } from 'react-i18next';

import { useToasts } from 'react-toast-notifications';
const ModalLogin = ({ modal, toggle }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const { addToast } = useToasts();
  const loginResponse = useSelector(({ login }) => login);
  const history = useHistory()
  const { t } = useTranslation([]);
  const onSubmit = (data) => {
    setIsLoading(true);
    const { email, password } = data;
    dispatch(cleanLoginError());
    dispatch(doLogin(email, password));
  };

  useEffect(() => {
    if (loginResponse) {
      setIsLoading(loginResponse.loading);
    }
  }, [loginResponse]);

  useEffect(() => {
    dispatch(cleanLoginError());
  }, []);

  return (
    <Modal
      isOpen={modal}
      toggle={toggle}
      style={{ width: 350 }}
      className={`${isLoading && 'standard whirl'}`}
    >
      <div
        style={{ justifyContent: 'center', marginTop: 40 }}
        className='text-center'
      >
        <span>{t('LoginModal.loginTitle')}</span>
      </div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div
          className='row'
          style={{ justifyContent: 'center', marginTop: 40 }}
        >
          <div className='col-md-10' style={{ display: 'flex' }}>
            <input
              type='email'
              placeholder={t('LoginModal.emailPlaceholder')}
              className='loginInput'
              {...register('email', {
                required: true,
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                  message: 'email does not match',
                },
              })}
              style={{
                border: errors.email ? 'solid 1px red' : 'solid 1px #A5A5A5',
              }}
            />
          </div>

          <div className='col-md-10' style={{ display: 'flex' }}>
            <input
              type='password'
              placeholder={t('LoginModal.passwordPlaceholder')}
              className='loginInput'
              type='password'
              {...register('password', { required: true })}
              style={{
                border: errors.password ? 'solid 1px red' : 'solid 1px #A5A5A5',
              }}
            />
          </div>
          {loginResponse && loginResponse.error && (
            <div
              style={{
                justifyContent: 'center',
                display: 'flex',
                width: '100%',
              }}
            >
              <p style={{ color: 'red', width: '80%', fontSize: 13 }}>
                {loginResponse.error}
              </p>
            </div>
          )}
          <div
            className='col-md-10'
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              marginTop: 20,
            }}
          >
            <Button
              color='primary'
              type='submit'
              className='loginBtn'
              style={{ backgroundColor: '#fe9900' }}
            >
              {t('LoginModal.loginButton')}
            </Button>
          </div>
          <div
            className='col-md-10'
            style={{ display: 'flex', marginBottom: 20 }}
          >
            <div className='loginmodal-container'>
              <a style={{cursor:'pointer'}} onClick={()=> {
                dispatch(cleanRecoveryEmail())
                history.push('/forgot')
              }} >
                {t('LoginModal.hyperlinkText')}
              </a>
            </div>
          </div>
        </div>
      </form>
    </Modal>
  );
};

export default ModalLogin;
